import { Box, Button, Grid, Stack } from '@mui/material';
import { useState } from 'react';
import { TitlePages } from '@/components/Base/TitlePage';
import KpiComponent from '@/components/Base/KpiComponent';
import PeriodFilterDash from '@/components/Base/PeriodFilterDash';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import TableBasicRankRaioInstitutions from '@/components/Base/TableBasicRankRaioInstitutions';
import RankingComponent from '@/components/Base/RankingComponent';

const RaioXInstituicao = () => {
  const generateLastYears = (numYears) => {
    const currentYear = dayjs().year();
    return Array.from({ length: numYears }, (_, index) => currentYear - index).reverse();
  };
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [listYears, setListYears] = useState(generateLastYears(5));

  const daysDiff = dayjs(selectedEndDate).diff(dayjs(selectedStartDate), 'day') || null;

  const filters = {
    ...(selectedYear && { year: selectedYear }),
  };

  return (
    <>
      <>
        <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
          <TitlePages title={'Instituições'} />
        </Stack>

        <Box
          padding={'15px'}
          sx={{
            border: '1px solid rgba(176, 176, 176, 1)',
            background: '#fff',
            borderRadius: '14px',
          }}
        >
          <Stack flexDirection={'row'} gap={'8px'}>
            <Stack
              flexDirection="row"
              maxWidth="100%"
              gap="8px"
              style={{
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                scrollbarWidth: 'thin',
                scrollbarColor: '#E04A4C #f1f1f1',
              }}
            >
              <KpiComponent title={'Média de notas'} 
                value={'10'} 
              />
              <KpiComponent title={'Maior resultado de avaliações'} 
                value={'10'} 
              />
              <KpiComponent title={'Maior índice de frequência'} 
                value={'10'} 
              />
            </Stack>
          </Stack>
          <Box marginTop={'10px'} marginBottom={'25px'}>
            <PeriodFilterDash
              startDate={selectedStartDate}
              endDate={selectedEndDate}
              onStartDateChange={setSelectedStartDate}
              onEndDateChange={setSelectedEndDate}
              refetchDashboard={() => console.log('teste')}
              listYears={listYears}
              setSelectedYear={setSelectedYear}
              setSelectedMonth={setSelectedMonth}
              selectedYear={selectedYear}
              selectedMonth={selectedMonth}
            />
          </Box>
          <Stack flexDirection={'row'} gap={'30px'}>
            <Box width={'50%'} flex={1}>
            <RankingComponent data={[{foto: 'AB', rank: 1, turma: 'serie a', aluno: 'João'}, {foto: 'AB', rank: 1, turma: 'serie a', aluno: 'João'}, {foto: 'AB', rank: 1, turma: 'serie a', aluno: 'João'}]}/>

            </Box>

            <Box width={'50%'} flex={1}>
              <TableBasicRankRaioInstitutions />
            </Box>
          </Stack>
        </Box>
      </>
    </>
  );
};

export default RaioXInstituicao;
